window.helmUpdateCartCount = async function () {
  try {
    const response = await fetch('/cart.js', {
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) return;

    const cart = await response.json();

    const itemCount = cart.items.reduce((total, item) => {
      const isHiddenUpsell =
        item.properties?._is_hidden_upsell === 'true';

      const isFastProcessing =
        item.properties?._fast_processing === 'true';

      if (isHiddenUpsell || isFastProcessing) {
        return total;
      }

      return total + item.quantity;
    }, 0);

    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      const count = bubble.querySelector('[aria-hidden="true"]');
      const label = bubble.querySelector('.visually-hidden');

      if (count) {
        count.textContent = itemCount;
      }

      if (label) {
        label.textContent = `${itemCount} ${
          itemCount === 1 ? 'item' : 'items'
        }`;
      }
    });

    return itemCount;
  } catch (error) {
    console.error('HELM cart count update failed:', error);
  }
};

function helmInitCartCount(attempt = 0) {
  if (document.querySelector('.cart-count-bubble')) {
    window.helmUpdateCartCount?.();
    return;
  }

  if (attempt < 10) {
    setTimeout(() => {
      helmInitCartCount(attempt + 1);
    }, 300);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    helmInitCartCount();
  });
} else {
  helmInitCartCount();
}

/*
async function syncVipProcessingCheckbox() {
  const checkbox =
    document.querySelector('#cart-upsell-checkbox');

  if (!checkbox) return;

  try {
    const response = await fetch('/cart.js', {
      cache: 'no-store'
    });

    if (!response.ok) return;

    const cart = await response.json();

    checkbox.checked = cart.items.some(
      (item) =>
        item.properties?._fast_processing === true ||
        item.properties?._fast_processing === 'true'
    );
  } catch (error) {
    console.warn(
      'Failed to sync VIP checkbox:',
      error
    );
  }
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    syncVipProcessingCheckbox,
    { once: true }
  );
} else {
  syncVipProcessingCheckbox();
}

*/

if (
  document.body.classList.contains('template-index') &&
  window.matchMedia('(max-width: 767px)').matches
) {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener('pageshow', () => {
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  });
}


const moveAccessibilityButton = () => {
  document.querySelectorAll('access-widget-ui').forEach((widget) => {
    const root = widget.shadowRoot;

    if (!root) return;

    const button = root.querySelector('[data-testid="acsb-trigger"]');

    if (!button) return;

    button.style.setProperty('top', 'auto', 'important');
    button.style.setProperty('bottom', '10vh', 'important');
    button.style.setProperty('right', '0', 'important');
    button.style.setProperty('left', 'auto', 'important');
  });
};

moveAccessibilityButton();

const accessibilityObserver = new MutationObserver(() => {
  moveAccessibilityButton();
});

accessibilityObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});

window.addEventListener('load', moveAccessibilityButton);



const VIP_PROCESSING_KEY = 'helm_vip_processing_preference';

async function syncVipProcessingCheckbox() {
  const checkbox = document.querySelector(
    '#cart-upsell-checkbox'
  );

  if (!checkbox) return;

  try {
    const response = await fetch('/cart.js', {
      cache: 'no-store'
    });

    if (!response.ok) return;

    const cart = await response.json();

    const hasVipProcessing = cart.items.some(
      (item) =>
        item.properties?._fast_processing === true ||
        item.properties?._fast_processing === 'true'
    );

    const preference = localStorage.getItem(
      VIP_PROCESSING_KEY
    );

    if (hasVipProcessing) {
      checkbox.checked = true;

      if (preference !== 'unchecked') {
        localStorage.setItem(
          VIP_PROCESSING_KEY,
          'checked'
        );
      }

      return;
    }

    if (preference === 'unchecked') {
      checkbox.checked = false;
      return;
    }

    if (preference === 'checked') {
      checkbox.checked = false;
      return;
    }

    checkbox.checked = true;

    localStorage.setItem(
      VIP_PROCESSING_KEY,
      'checked'
    );

    checkbox.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  } catch (error) {
    console.warn(
      'Failed to sync VIP checkbox:',
      error
    );
  }
}

function initVipProcessingPreference() {
  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest(
      '#cart-upsell-checkbox'
    );

    if (!checkbox) return;

    localStorage.setItem(
      VIP_PROCESSING_KEY,
      checkbox.checked ? 'checked' : 'unchecked'
    );
  });
}

function initVipProcessingObserver() {
  let currentCheckbox = null;
  let syncTimer;

  const sync = () => {
    const checkbox = document.querySelector(
      '#cart-upsell-checkbox'
    );

    if (!checkbox || checkbox === currentCheckbox) {
      return;
    }

    currentCheckbox = checkbox;

    clearTimeout(syncTimer);

    syncTimer = setTimeout(() => {
      syncVipProcessingCheckbox();
    }, 100);
  };

  sync();

  const observer = new MutationObserver(() => {
    sync();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function initHelmVipProcessing() {
  initVipProcessingPreference();
  initVipProcessingObserver();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initHelmVipProcessing,
    { once: true }
  );
} else {
  initHelmVipProcessing();
}

if (
  document.body.classList.contains('template-index') &&
  window.matchMedia('(max-width: 767px)').matches
) {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener('pageshow', () => {
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  });
}